import { useContext } from 'react';

import './styles.scss';
import Input from '../../../../components/input/input';
import PricingGroup from '../../../../components/pricing-group';
import Select from '../../../../components/select/select';
import { PricingContext } from '../../../../providers/pricing-provider';

export interface ModelParameters {
  num_x_points: number;
  num_y_points: number;
  num_t_points: number;
  num_x_std_devs: number;
  num_y_std_devs: number;
}

const MODEL_OPTIONS = [
  { name: 'BS (1F PDE)', value: 'BS' },
  { name: 'LV (1F PDE)', value: 'LV' },
  { name: 'SV (2F PDE)', value: 'SV' },
];

const PARAM_LABELS: Record<keyof ModelParameters, string> = {
  num_x_points: 'X Points',
  num_y_points: 'Y Points',
  num_t_points: 'T Points',
  num_x_std_devs: 'X Std Devs',
  num_y_std_devs: 'Y Std Devs',
};

const getActiveParams = (model: string): (keyof ModelParameters)[] => {
  switch (model) {
    case 'BS':
    case 'LV':
      return ['num_x_points', 'num_t_points', 'num_x_std_devs'];
    case 'SV':
      return ['num_x_points', 'num_y_points', 'num_t_points', 'num_x_std_devs', 'num_y_std_devs'];
    default:
      return [];
  }
};

const PricingModel = () => {
  const { trades, getTradeModel, setTradeModel, getTradeModelParams } = useContext(PricingContext);

  return (
    <div className="pricing-data">
      <PricingGroup label={'Model'} isClosable defaultOpen={true}>
        <div className="content-header">
          <div className="content-header-items">
            <div className="content-header-items-fixed">Pricing Model</div>
            {trades.map((trade) => {
              const tradeModel = getTradeModel(trade.id);
              const selectedModel =
                MODEL_OPTIONS.find((opt) => opt.value === tradeModel) || MODEL_OPTIONS[0];

              return (
                <div className="content-header-items-trade" key={trade.id}>
                  <Select
                    values={MODEL_OPTIONS}
                    defaultValue={selectedModel}
                    onChange={(value) => setTradeModel(trade.id, value)}
                    className="select-model"
                  />
                </div>
              );
            })}
            <div className="content-header-items-trade"></div>
          </div>
        </div>
        <div className="pricing-data-container">
          <div className="fixed-panel">
            {Object.keys(PARAM_LABELS).map((key) => (
              <span key={key} className="item">
                {PARAM_LABELS[key as keyof ModelParameters]}
              </span>
            ))}
          </div>
          <div className="content-panel">
            {trades.map((trade) => {
              const tradeModel = getTradeModel(trade.id);
              const modelParams = getTradeModelParams(trade.id);
              const activeParams = getActiveParams(tradeModel);

              return (
                <div key={trade.id} className="block">
                  {(Object.keys(PARAM_LABELS) as (keyof ModelParameters)[]).map((paramKey) => {
                    const isActive = activeParams.includes(paramKey);
                    const displayValue = isActive ? String(modelParams[paramKey]) : '';
                    return (
                      <div key={paramKey} className="item-row">
                        <Input value={displayValue} disabled className="param-input" />
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>
        </div>
      </PricingGroup>
    </div>
  );
};

export default PricingModel;
